package fyi.moko.hotpl.ui.detail

/**
 * 방문 사진 섹션의 문구. Compose에서 떼어 둔 이유는 [fyi.moko.hotpl.ui.directory.formatDistance]
 * 와 같다 — 화면 안에 있으면 테스트가 못 닿는다.
 *
 * 한국어에는 수 일치가 없어 "$n 장은 …" 한 문장으로 끝났지만, 영어는 단수·복수가 갈린다.
 * 화면 안에 두면 조용히 "1 photos"가 나가는 종류의 실수다.
 */
internal fun undecidedPhotoNotice(count: Int): String = when (count) {
    1 -> "One photo couldn't be identified, so it went to today's entry. Tap it to move it."
    else -> "$count photos couldn't be identified, so they went to today's entry. Tap one to move it."
}
